import React, { useEffect, useState } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { HelperText, TextInput } from 'react-native-paper';
import PropTypes from 'prop-types';

import { Scenario, ScenarioDialog } from './Scenarios';

export default function PlantingDistribution({
  actions,
  appStyles,
  pageContent,
  unit,
  toggleDisableNextStep,
}) {
  const { handleChange, handleBlur, touched, values, errors } = actions;
  const [plantingDistribution, setPlantingDistribution] = useState(0);
  const [scenario, setScenario] = useState(undefined);
  const [visible, setVisible] = useState(false);

  const showDialog = () => setVisible(true);

  function totalPlantingDistribution(crops) {
    return crops
      .map((crop) =>
        parseFloat(crop.plantDistribution)
          ? parseFloat(crop.plantDistribution)
          : 0
      )
      .reduce((a, b) => a + b);
  }

  useEffect(() => {
    let disable = false;
    let totalPerc = 0;

    values.crops.forEach((crop, index) => {
      if (
        errors.crops &&
        errors.crops[index] &&
        errors.crops[index].plantDistribution
      ) {
        disable = true;
      }
      totalPerc += parseFloat(crop.plantDistribution);
    });

    if (totalPerc !== 100) {
      disable = true;
    }

    toggleDisableNextStep(disable);
  }, [errors, touched, values]);

  useEffect(() => {
    if (values.crops.length > 0) {
      setPlantingDistribution(totalPlantingDistribution(values.crops));
    }
  }, [values.crops]);

  return (
    <View style={styles.container}>
      <Scenario
        scenario={pageContent[0]}
        setScenario={setScenario}
        showDialog={showDialog}
      />
      <ScenarioDialog
        scenario={scenario}
        setVisible={setVisible}
        visible={visible}
      />
      <Text>{pageContent[1]}</Text>
      {values.crops.map((crop, index) => (
        <View key={`ctp-${crop.name}`}>
          <TextInput
            key={crop.name}
            mode={'outlined'}
            style={styles.textInput}
            label={`${crop.name.toUpperCase()[0]}${crop.name.slice(
              1
            )} (${unit})`}
            keyboardType="number-pad"
            onChangeText={handleChange(`crops.${index}.plantDistribution`)}
            onBlur={handleBlur(`crops.${index}.plantDistribution`)}
            value={values.crops[index].plantDistribution}
            error={
              touched.crops &&
              touched.crops[index] &&
              touched.crops[index].plantDistribution &&
              errors.crops &&
              errors.crops[index] &&
              errors.crops[index].plantDistribution
                ? errors.crops[index].plantDistribution
                : null
            }
          />
          {touched.crops &&
          touched.crops[index] &&
          touched.crops[index].plantDistribution &&
          errors.crops &&
          errors.crops[index] &&
          errors.crops[index].plantDistribution ? (
            <HelperText type="error" styles={appStyles.helperTextError}>
              {errors.crops[index].plantDistribution}
            </HelperText>
          ) : null}
        </View>
      ))}
      {
        <HelperText
          type={plantingDistribution !== 100 ? 'error' : 'info'}
          style={
            plantingDistribution !== 100
              ? appStyles.helperTextError
              : appStyles.helperText
          }
        >
          {pageContent[2]}
          {plantingDistribution}%
        </HelperText>
      }
    </View>
  );
}

PlantingDistribution.propTypes = {
  actions: PropTypes.shape({
    handleChange: PropTypes.func,
    handleBlur: PropTypes.func,
    touched: PropTypes.object,
    values: PropTypes.object,
    errors: PropTypes.object,
  }),
  appStyles: PropTypes.object,
  pageContent: PropTypes.array,
  toggleDisableNextStep: PropTypes.func,
  unit: PropTypes.string,
};

const styles = StyleSheet.create({
  button: { alignSelf: 'flex-start' },
  container: {
    flex: 1,
  },
  textInput: {
    marginTop: 15,
  },
});
